var _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 13,
    rx: 13,
    ry: 13,
    fill: "#D7F3DD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1355_12557)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.646 9.22977C18.7504 9.27144 18.8399 9.34345 18.903 9.43649C18.9661 9.52953 18.9999 9.63935 19 9.75177V16.2483C18.9999 16.3607 18.9661 16.4705 18.903 16.5636C18.8399 16.6566 18.7504 16.7286 18.646 16.7703L13.2085 18.9453C13.0744 18.9989 12.9248 18.9989 12.7908 18.9453L7.35325 16.7703C7.24898 16.7285 7.1596 16.6564 7.09665 16.5634C7.03369 16.4704 7.00003 16.3606 7 16.2483V9.75177C7.00003 9.63944 7.03369 9.52968 7.09665 9.43665C7.1596 9.34361 7.24898 9.27156 7.35325 9.22977L12.5822 7.13802L12.5852 7.13727L12.7908 7.05477C12.9251 7.00095 13.0749 7.00095 13.2093 7.05477L13.4148 7.13727L13.4178 7.13802L18.646 9.22977ZM17.6155 9.62502L13 11.4715L8.3845 9.62502L7.75 9.87927V10.1793L12.625 12.1293V18.0708L13 18.2208L13.375 18.0708V12.13L18.25 10.18V9.88002L17.6155 9.62502Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16.0845C9 16.0147 9.0696 15.9664 9.13495 15.9908L10.435 16.4757C10.4741 16.4903 10.5 16.5277 10.5 16.5694V16.9155C10.5 16.9852 10.4304 17.0336 10.365 17.0092L9.06505 16.5242C9.02593 16.5096 9 16.4723 9 16.4305V16.0845Z",
    fill: "#16A02C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1355_12557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.515f1da98b5a276add2db947a2ff6d03.svg";
export { ForwardRef as ReactComponent };